<div>
    <mat-dialog-content class="">
        <button (click)="closeDialogue()" class="m-show m-back-arrow" type="button"><img
                src="assets/img/m-back-arrow-dark.svg" alt=""></button>
        <div class="font-14 heading">
            <h4>{{ data?.message }}<span><button class="closeButton m-hide" (click)="closeDialogue()">X</button></span>
            </h4>
        </div>
        <div class="assessment_py-10 font-8">
            {{ data?.message2 }}
        </div>
        <form  [formGroup]="loginWithAdmissionNumberForm">
            <div class="setup-account-input-icons">
                <img class="setup-account-icon" src="assets/img/admission-number-icon-dark.svg" alt="" />
                <input [maxlength]="maxLength" oncopy="return false" class="form-control setup-account-input-field-left"
                    type="text" formControlName="admissionNumber" [placeholder]="placeHolder">
                <mat-error class="error-msg"
                    *ngIf="lAdmissionNumber.admissionNumber.touched && lAdmissionNumber.admissionNumber.errors?.required">
                    {{placeHolder}} is required
                </mat-error>
                <mat-error class="error-msg"
                    *ngIf="lAdmissionNumber.admissionNumber.touched && 
                    !lAdmissionNumber.admissionNumber.errors?.required &&
                    lAdmissionNumber.admissionNumber.errors?.pattern">
                    Please enter a valid {{placeHolder}}
                </mat-error>
            </div>
            <div class="setup-account-input-icons">
                <img class="setup-account-icon" src="assets/img/password-lock.svg" alt="" />
                <input oncopy="return false" onpaste="return false" class="form-control setup-account-input-field-left"
                    [type]="show_button ? 'text' : 'password'" formControlName="password" placeholder="Password">
                <mat-icon class="font-16 cursor-pointer field-icon" matSuffix (click)="showPassword()">{{show_button ?
                    'visibility_off' : 'visibility'}}</mat-icon>

                <mat-error class="error-msg"
                    *ngIf="lAdmissionNumber.password.touched && lAdmissionNumber.password.errors?.required">
                    Required
                </mat-error>
                <mat-error class="error-msg"
                    *ngIf="lAdmissionNumber.password.touched && lAdmissionNumber.password.errors?.minlength">
                    Password should be atleast 6 characters
                </mat-error>
                <mat-error class="UnauthorizedErrorMessage">{{UnauthorizedLoginMessage}}</mat-error>
            </div>
            <div class="d-flex justify-content-center IL_sc-click font-weight-bold  assessment_mb-10">
                <span>Forgot Password? - <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">Click Here</span></span>
            </div>  
            <button class="btn btn-primary btn-block" type="button" (click)="loginWithAdmissionNumber()">LOGIN</button>
        </form>
    </mat-dialog-content>
</div>